/**
 * Is the Hand helper (Suggestions) available in this game? One answer for the host's screen and a guest's.
 *
 * Off in a leaderboard game, always — the helper is advice during play, which has no place where the venue's board is decided. A
 * leaderboard game's settings also carry the switch as off (`periodRulesToSettings`), because a guest's phone only has the settings,
 * not the leaderboard record. Otherwise it follows the House Rules switch, on unless that says false (a game saved before the switch
 * existed has no value, and counts as on).
 */

import type { Game } from './types';

export function handHelperOn(game: Pick<Game, 'settings' | 'leaderboard'>): boolean {
  if (game.leaderboard) return false;
  const toggles = (game.settings as { toggles?: { handHelper?: unknown } } | undefined)?.toggles;
  return toggles?.handHelper !== false;
}
